import request from '@/utils/request'

let devRes = {
    'code': 200,
    'message': 'success',
    'data': []
}
class CustomApi {
   constructor (path, records = devRes) {
    this.path = path
    this.devRecords = records
   }
   async getRecords (params) {
    // if (process.env.NODE_ENV !== 'production') return this.devRecords
    let res = await request.get(`/${this.path}/select`, {
        params
      })
      return res.data
   }

   async addRecord (params) {
    // if (process.env.NODE_ENV !== 'production') return devRes
    let res = await request.post(`/${this.path}/add`, params)
    return res.data
   }

   async updateRecord (params) {
    // if (process.env.NODE_ENV !== 'production') return devRes
    let res = await request.post(`/${this.path}/update`, params)
    return res.data
   }

   async deleteRecord (params) {
    // if (process.env.NODE_ENV !== 'production') return devRes
    let res = await request.get(`/${this.path}/deleteById`, { params })
    return res.data
   }
}

export default CustomApi
